import { IconButton, styled } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { COLORS } from 'shared/constants/COLORS';
import { BROWSER } from 'shared/constants/BROWSER';

export const EditProfileContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: 10,
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    gap: BROWSER.safari ? 20 : 10,

    '& > :nth-child(1)': {
      flexShrink: 0,
    },
    '& > :nth-child(2)': {
      flex: 1,
    },
  },
}));

export const EditProfileCustomSkeleton = styled(Skeleton)({
  borderRadius: 8,
});

export const EditProfileCircularProgressContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const EditProfileNumberBox = styled('aside')(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: COLORS.PRIMARY,
  color: COLORS.WHITE,
  borderRadius: 4,
  padding: 1,
  top: 5,
  left: 5,
  width: 15,
  height: 15,
  fontSize: 7,

  '& svg': {
    width: 7,
    height: 7,
  },

  [theme.breakpoints.up('sm')]: {
    width: 20,
    height: 20,
    fontSize: 10,

    '& svg': {
      width: 10,
      height: 10,
    },
  },
  [theme.breakpoints.up('lg')]: {
    width: 25,
    height: 25,
    fontSize: 14,

    '& svg': {
      width: 14,
      height: 14,
    },
  },
}));

export const EditProfileDragContainer = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: COLORS.DARK_BACKGROUND,
  cursor: 'move',
  padding: 1,
  top: 5,
  right: 5,
  width: 15,
  height: 15,
  fontSize: 7,
  '&:hover': {
    backgroundColor: COLORS.DARK_BACKGROUND,
  },

  '& svg': {
    width: 7,
    height: 7,
  },

  [theme.breakpoints.up('sm')]: {
    width: 20,
    height: 20,

    '& svg': {
      width: 10,
      height: 10,
    },
  },
  [theme.breakpoints.up('lg')]: {
    width: 25,
    height: 25,
    '& svg': {
      width: 14,
      height: 14,
    },
  },
}));
